"use client";

import React from "react";
import type { AIInsightsWidgetProps } from "./types";
import AIInsightsCard from "./AIInsightsCard";
import { useAIInsights } from "@/hooks/useAIInsights";

const DEFAULT_TITLE = "AI Page Insight";
const DEFAULT_DESCRIPTION = "Summarize key solutions, benefits, and business value.";

const AIInsightsWidget: React.FC<AIInsightsWidgetProps> = ({
  delay = 3000,
  position = "right",
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  prompt,
}) => {
  const { isVisible, isExpanded, handleGetInsights, handleToggle, handleHoverEnter, handleHoverLeave } =
    useAIInsights({ delay, prompt });

  if (!isVisible) return null;

  return (
    <AIInsightsCard
      title={title}
      description={description}
      isExpanded={isExpanded}
      onGetInsights={handleGetInsights}
      onToggle={handleToggle}
      onMouseEnter={handleHoverEnter}
      onMouseLeave={handleHoverLeave}
      position={position}
    />
  );
};

export default AIInsightsWidget;
